export default __webpack_public_path__ + "static/liza-4ab580012c142a12746d3a6946f7d9ac.png";